const companiesList = {
  listBreadcrumb: "الشركات",
  searchPlaceholder: "بحث الشركات",
  statusFilter: "الحالة",
  allStatuses: "الكل",
  createdFrom: "تاريخ الإنشاء من",
  createdTo: "تاريخ الإنشاء إلى",
  companyName: "اسم الشركة",
  companyId: "المعرّف",
  contactPerson: "جهة الاتصال",
  city: "المدينة",
  countryLabel: "الدولة",
  createdDate: "تاريخ الإنشاء",
  numberOfEvents: "عدد الفعاليات",
  status: "الحالة",
  active: "نشط",
  deactivated: "غير نشط",
  pending: "قيد الانتظار",
  rejected: "مرفوض",
  viewDetails: "عرض التفاصيل",
  deactivate: "إلغاء التفعيل",
  activate: "تفعيل",
  addCompany: "إضافة شركة",
  // Deactivating a company from the Companies list (PROLINE-4124).
  deactivation: {
    menuAction: "إيقاف",
    title: "إيقاف حساب الشركة",
    message:
      "أنت على وشك إيقاف {company}. سيتوقف استخدام الشركة ليورم وستُلغى فعالياتها الجارية.",
    eventsCount: "عدد الفعاليات التي ستُلغى: {count}",
    eventsCountOne: "ستُلغى فعالية واحدة",
    warnings: [
      "تُلغى كل فعالية قادمة أو جارية ولا يمكن استعادتها.",
      "لا تتأثر الفعاليات المكتملة والملغاة مسبقًا.",
      "لن يتمكن أي مستخدم في هذه الشركة من تسجيل الدخول.",
    ],
    reasonLabel: "السبب",
    reasonPlaceholder: "اكتب رسالتك هنا...",
    reasonMaxLengthError: "لا يمكنك إدخال أكثر من 300 حرف.",
    detailsTitle: "إيقاف الشركة",
    detailsDateLabel: "تم الإيقاف في",
    cancel: "إلغاء",
    confirm: "إيقاف",
    successTitle: "تم إيقاف {company}",
    successMessage: "عدد الفعاليات التي أُلغيت: {count}. لن يتمكن مستخدمو الشركة من تسجيل الدخول بعد الآن.",
    successMessageOne: "أُلغيت فعالية واحدة. لن يتمكن مستخدمو الشركة من تسجيل الدخول بعد الآن.",
  },
  // Activating a deactivated company from the Companies list (PROLINE-4141).
  activation: {
    menuAction: "تفعيل",
    title: "تفعيل الشركة",
    message: "ستتمكن {company} من استخدام يورم مرة أخرى، ويمكن لمستخدميها تسجيل الدخول.",
    warningTitle: "لن تتم استعادة الفعاليات الملغاة",
    warnings: [
      "تظل الفعاليات التي أُلغيت بسبب الإيقاف ملغاة.",
      "لا يمكن إعادة فتح فعالية ملغاة. تنشئ الشركة فعالية جديدة من البداية.",
      "تتم إعادة تفعيل الشركة فقط.",
    ],
    cancel: "إلغاء",
    confirm: "تفعيل الشركة",
    successTitle: "تم تفعيل {company}",
    successMessage: "يمكن لمستخدمي الشركة تسجيل الدخول مرة أخرى.",
  },
  noCompaniesTitle: "لا توجد شركات بعد",
  noCompaniesDescription:
    "يبدو أنك لم تضف أي شركات إلى قائمتك. ابدأ بإنشاء أول ملف شركة لإدارة الفعاليات والمتقدمين.",
  showingRange: "عرض {from}–{to} من أصل {total} شركة",
  editPageTitle: "تعديل الشركة",
  editPageHint: "حدّث حقول اسم الشركة أدناه.",
  nameEn: "الاسم (إنجليزي)",
  nameAr: "الاسم (عربي)",
  companyProfile: "ملف الشركة",
  overviewTab: "نظرة عامة",
  financialsPayrollTab: "المالية والرواتب",
  pendingRequestsTab: "طلبات معلقة",
  clientsTab: "العملاء",
  teamPermissionsTab: "الفريق والصلاحيات",
  logsTab: "السجلات",
  subscriptionTab: "الاشتراك",
  // Company subscription plan and its upgrade by the Super Admin (PROLINE-4122).
  subscription: {
    yearlyPrice: "{price} ريال / سنة",
    dailyRate: "اليومي: {rate} ريال / يوم",
    extendedRate: "الممتد: {rate} ريال للفعالية",
    startDate: "تاريخ البدء: {date}",
    renews: "التجديد: {date}",
    changePlan: "تغيير الباقة",
    highestPlan: "هذه الشركة على أعلى باقة.",
    /** Fallbacks when the backend sends no message (PROLINE-4150). */
    changed: "تم تغيير باقة الاشتراك.",
    changeFailed: "حدث خطأ أثناء تغيير الباقة. يرجى المحاولة مرة أخرى.",
    /** The company's own view on its profile, read only (PROLINE-4123). */
    companyProfile: {
      title: "اشتراك الشركة",
      changePlanTitle: "غيّر باقتك",
      changePlanMessage: "تريد تغيير باقتك؟ تواصل مع فريقنا على {email} وسنساعدك.",
    },
    modal: {
      title: "ترقية باقة الاشتراك",
      description: "غيّر باقة اشتراك هذه الشركة - يسري السعر الجديد فوراً.",
      current: "الحالية:",
      currentValue: "{plan} - {price} ريال / سنة",
      newPlan: "الباقة الجديدة",
      newPlanValue: "{plan} (كانت {current})",
      price: "السعر",
      priceValue: "{price} ريال / سنة - باقة {plan}",
      difference: "الفرق المطلوب دفعه",
      differenceValue: "{amount} ريال",
      noticeTitle: "يسري فورًا",
      noticeMessage:
        "تسري باقتك الجديدة بمجرد التأكيد، دون الحاجة إلى موافقة. فرق السعر أعلاه هو الفرق بين السعر السنوي للباقتين، وتبقى سنة الفوترة وتاريخ التجديد كما هما.",
      confirm: "تأكيد الترقية",
    },
  },
  overviewStatTotalEvents: "إجمالي الفعاليات",
  overviewStatOngoingEvents: "فعاليات قيد التنفيذ",
  overviewStatTotalRevenue: "إجمالي الإيرادات",
  overviewStatTotalApplicants: "إجمالي المتقدمين",
  overviewStatCurrency: "ر.س",
  editCompanyProfile: "تعديل ملف الشركة",
  generalInformation: "معلومات عامة",
  englishName: "الاسم بالإنجليزية",
  arabicName: "الاسم بالعربية",
  cityLabel: "المدينة",
  fullName: "الاسم الكامل",
  mobileNumber: "رقم الجوال",
  emailAddress: "البريد الإلكتروني",
  commercialRecordLabel: "السجل التجاري",
  cannotBeEdited: "لا يمكن تعديله",
  cannotBeEditedEmail: "لا يمكن تعديله",
  documents: "المستندات",
  delegationDocument: "وثيقة التفويض",
  idDocument: "وثيقة الهوية",
  commercialRecordDocument: "السجل التجاري (وثيقة السجل التجاري)",
  download: "تنزيل",
  replace: "استبدال",
  removeDocument: "إزالة",
  confirmRemoveTitle: "إزالة المستند",
  confirmRemoveBody: "هل أنت متأكد أنك تريد إزالة هذا المستند؟",
  logoUploadHint: "JPG أو PNG أو SVG. الحجم الأقصى 2 ميجابايت.",
  logoUploadChange: "تغيير",
  saveChanges: "حفظ التغييرات",
  logoUploadFailed: "تعذّر رفع الشعار. حاول مرة أخرى.",
  commercialRecordUploadFailed: "تعذّر رفع السجل التجاري. حاول مرة أخرى.",
  delegationDocumentUploadFailed:
    "تعذّر رفع وثيقة التفويض. حاول مرة أخرى.",
  idDocumentUploadFailed: "تعذّر رفع مستند الهوية. حاول مرة أخرى.",
  pendingProfileRequest:  "طلب الملف الشخصي معلّق",
  reviewRequest: "مراجعة الطلب",
  pendingProfileUpdateRequest: "طلب تحديث الملف الشخصي معلّق",
  submittedOn: "تم الإرسال في {date}",
  reviewProfileUpdateRequest: "مراجعة طلب تحديث الملف الشخصي",
  approveUpdate: "الموافقة على التحديث",
  rejectUpdateRequest: "رفض الطلب",
  changesSummary: "ملخص التغييرات",
  changesSummaryLegendNewTitle: "الحقول المميّزة",
  changesSummaryLegendNewDesc: "تعرض القيم الجديدة المطلوب اعتمادها",
  changesSummaryLegendOldTitle: "النص المشطوب",
  changesSummaryLegendOldDesc: "تعرض القيم السابقة التي سيتم استبدالها",
  rejectEditRequestModalTitle: "رفض طلب التعديل",
  rejectEditRequestModalDescription:
    "يُرجى إدخال سبب لرفض هذا التحديث. ستظهر هذه الملاحظة لمسؤول الشركة.",
  rejectEditRequestReasonLabel: "السبب",
  rejectEditRequestReasonPlaceholder:
    "مثال: يُرجى تقديم نسخ أوضح من المستندات...",
  confirmRejectEditRequest: "تأكيد الرفض",
  totalChanges: "إجمالي التغييرات",
  totalChangesFields: "{count} حقول",
  editRequestLoadError: "تعذّر تحميل طلب التعديل. يُرجى المحاولة مرة أخرى.",
  noActiveEditRequest: "لا يوجد طلب تحديث ملف قيد الانتظار لهذه الشركة.",
  documentUpdated: "تم تحديث المستند",
  documentChanges: "تغييرات المستندات",
  documentType: "نوع المستند",
  currentDocument: "المستند الحالي",
  newSubmission: "الإرسال الجديد",
  previewNew: "معاينة الجديد",
  viewCurrent: "عرض الحالي",
  viewOldDoc: "عرض المستند القديم",
  noUpdateSubmittedForDocument: "لم يتم إرسال تحديث لهذا المستند",
  requestAccountDeletion: "طلب حذف الحساب",
};

export default companiesList;
